import { Chip, CircularProgress, Grid, makeStyles } from "@material-ui/core";
import { Add, InfoOutlined } from "@material-ui/icons";
import { useAuth } from "@airborne/react-admin";
import React, { useState } from "react";
import {
  Button,
  Create,
  NumberInput,
  SelectInput,
  TextInput,
  Toolbar,
  minValue,
  required,
  useNotify,
} from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import { ExperienceNoteType } from "../../../../../src/Enums/ExperienceNoteType";
import { PbhRequestFileType } from "../../../../../src/Enums/PbhRequestFileType";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import { SectionTitle } from "../../../../Components/SectionTitle";
import { Separator } from "../../../../Components/Separator";
import { GetCarrierType } from "../../../../Enums/CarrierType";
import { PbhSvcShipmentTypeEnum } from "../../../../Enums/PbhSvcShipmentType";
import { ServiceableStatu } from "../../../../Enums/ServiceableStatus";
import { useAppDataProvider } from "../../../../dataprovider";
import { PbhRequestServiceablePostModel } from "../../Models/PbhRequestServiceableModel";
import ExperienceSoftWarningDialog from "../ExperiencePopup";
import OrderTypesEnum from "../../../../../src/Enums/OrderTypes";
import { PbhRequestStatus } from "../../../../../src/Enums/PbhRequestStatus";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const useStyles = makeStyles({
  toolbar: {
    display: "flex",
    justifyContent: "end",
    backgroundColor: "white",
  },
  defaultToolbar: {
    display: "flex",
    justifyContent: "end",
  },
});

const ServiceableCreate = props => {
  const { user } = useAuth();
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [shipmentTypeList, setShipmentTypeList] = useState<any[]>([]);
  const [orderTypeList, setOrderTypeList] = useState<any[]>([]);
  const [orderNumberAndTypeVisible, setOrderNumberAndTypeVisible] = useState(false);
  const requestId = props.requestId;
  const isDomesticDestination = props?.requestDetail?.isDomesticDestination;

  const classes = useStyles();

  React.useEffect(() => {
    GetShipmentTypeList();
    GetOrderTypeList();
  }, []);
  const CreateServiceableButtonClick = e => {
    CreateServiceable(e);
  };

  const isDisabledProcess = values => () => {
    if (props.isPageDisabled) {
      return true;
    }
    if (props?.requestDetail?.requestStatus === PbhRequestStatus.Cancelled) {
      return true;
    }
    if (values.isCid === true) {
      var cidFileCheck =
        props?.requestDetail?.pbhRequestOrderFiles?.filter?.(
          x =>
            x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Serviceable &&
            x.pbhRequestFileTypeEnum === PbhRequestFileType.Cid
        )?.length === 0;
      if (cidFileCheck == true) return true;
    }
    if (isDomesticDestination) {
      let formOneShopReport =
        props?.requestDetail?.pbhRequestOrderFiles?.filter?.(
          x =>
            x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Serviceable &&
            x.pbhRequestFileTypeEnum === PbhRequestFileType.FormOneShopReport
        ).length === 0;
      if (formOneShopReport === false) return false;
      let formOne =
        props?.requestDetail?.pbhRequestOrderFiles?.filter?.(
          x =>
            x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Serviceable &&
            x.pbhRequestFileTypeEnum === PbhRequestFileType.FormOne
        ).length === 0;
      let shopReport =
        props?.requestDetail?.pbhRequestOrderFiles?.filter?.(
          x =>
            x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Serviceable &&
            x.pbhRequestFileTypeEnum === PbhRequestFileType.ShopReport
        ).length === 0;

      if (formOne === false && shopReport === false) return false;
      return true;
    }

    let shippingInvoiceAwb =
      props?.requestDetail?.pbhRequestOrderFiles?.filter(
        x =>
          x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Serviceable &&
          x.pbhRequestFileTypeEnum === PbhRequestFileType.ShippingInvoiceAwb
      ).length === 0;
    if (shippingInvoiceAwb === false) return false;
    let awb =
      props?.requestDetail?.pbhRequestOrderFiles?.filter(
        x =>
          x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Serviceable &&
          x.pbhRequestFileTypeEnum === PbhRequestFileType.Awb
      ).length === 0;
    let shippingInvoice =
      props?.requestDetail?.pbhRequestOrderFiles?.filter(
        x =>
          x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Serviceable &&
          x.pbhRequestFileTypeEnum === PbhRequestFileType.ShippingInvoice
      ).length === 0;
    if (awb === false && shippingInvoice === false) return false;
    return true;
  };

  const CreateServiceable = async e => {
    let pbhrequestServiceableCreateModel: PbhRequestServiceablePostModel = new PbhRequestServiceablePostModel();
    pbhrequestServiceableCreateModel.RequestId = requestId;
    pbhrequestServiceableCreateModel.Awb = e.awb;
    pbhrequestServiceableCreateModel.CarrierEnum = e.carrierEnum;
    pbhrequestServiceableCreateModel.EstimatedDeliveryDate = e.estimatedDeliveryDate;
    pbhrequestServiceableCreateModel.FlightNo = e.flightNo;
    pbhrequestServiceableCreateModel.Pn = e.pn;
    pbhrequestServiceableCreateModel.Sn = e.sn;
    pbhrequestServiceableCreateModel.Status = ServiceableStatu.Offered;
    pbhrequestServiceableCreateModel.SubmittedBy = user?.employeeId;
    pbhrequestServiceableCreateModel.SubmittedDate = new Date();
    pbhrequestServiceableCreateModel.ForwardDateToCarrier = e.forwardDateToCarrier;
    pbhrequestServiceableCreateModel.XoNo = e.xoNo?.toString();
    pbhrequestServiceableCreateModel.ShipmentType = Number(e.shipmentType);
    pbhrequestServiceableCreateModel.IsCid = e.isCid;
    pbhrequestServiceableCreateModel.CidDescription = e.cidDescription;
    if (orderNumberAndTypeVisible) {
      pbhrequestServiceableCreateModel.OrderNumber = e.orderNumber;
      pbhrequestServiceableCreateModel.OrderType = e.orderType;
    }

    PostCreate(pbhrequestServiceableCreateModel);
  };

  const PostCreate = async (createModel: PbhRequestServiceablePostModel) => {
    setLoading(true);
    dataProvider
      .postPbhRequestServiceable(createModel)
      .then(result => {
        props?.finalCallBack?.();
        notify(`Record created`, "success", false, true);
        history.push("/pbhrequestorders/" + requestId + "/1");
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };
  const GetShipmentTypeList = () => {
    dataProvider
      .getList("ParameterDefinitions", {
        pagination: { page: 1, perPage: 500 },
        sort: { field: "id", order: "DESC" },
        filter: { parameterGroupCode__eq: PbhSvcShipmentTypeEnum.PbhSvcShipmentType },
      })
      .then(result => {
        setShipmentTypeList(result?.data ?? []);
      })
      .catch(result => console.error(result));
  };
  const GetOrderTypeList = () => {
    dataProvider
      .getList("ParameterDefinitions", {
        pagination: { page: 1, perPage: 500 },
        sort: { field: "id", order: "DESC" },
        filter: { parameterGroupCode__eq: OrderTypesEnum.OrderTypes },
      })
      .then(result => {
        setOrderTypeList(result?.data ?? []);
      })
      .catch(result => console.error(result));
  };

  const resetValidate = form => e => {
    setTimeout(() => form?.restart?.(form?.getState?.()?.values), 500);
  };
  const onChangeShipType = e => {
    if (Number(e.target.value) === Number(PbhSvcShipmentTypeEnum.DropShipment)) {
      setOrderNumberAndTypeVisible(true);
    } else {
      setOrderNumberAndTypeVisible(false);
    }
  };

  return (
    <>
      <Form
        onSubmit={CreateServiceableButtonClick}
        render={({ handleSubmit, form, values }) => (
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <Create {...props}>
                  <>
                    <Separator />
                    <Grid {...gridContainerProps}>
                      <Grid container xs={12} sm={12} justifyContent="center">
                        <SectionTitle label="Serviceable Info" />
                      </Grid>
                      <Grid container xs={12} sm={12} justifyContent="flex-end" style={{ margin: 5 }}>
                        {isDomesticDestination === false ? (
                          <Chip
                            key={9999990}
                            color="primary"
                            variant="outlined"
                            label="Please Upload AWB File & Shipping Invoice For Serviceable Separately Or Single Shipping Invoice & AWB File"
                            icon={<InfoOutlined />}
                          />
                        ) : (
                          <Chip
                            key={9999991}
                            color="primary"
                            variant="outlined"
                            label="Please Upload Form One & Shop Report For Serviceable Separately Or Single Form One & Shop Report File"
                            icon={<InfoOutlined />}
                          />
                        )}
                      </Grid>
                      <Grid container xs={12} sm={12} justifyContent="flex-end" style={{ margin: 5 }}>
                        {values?.isCid === true && (
                          <Chip
                            key={9999992}
                            color="primary"
                            variant="outlined"
                            label="If you have enabled the 'is Cid' field, please upload a file of type 'Cid'."
                            icon={<InfoOutlined />}
                          />
                        )}
                      </Grid>
                    </Grid>

                    <Separator />
                    <Grid {...gridContainerProps}>
                      <Grid item xs={12} sm={5}>
                        <TextInput
                          source="pn"
                          label="PN"
                          fullWidth
                          resettable
                          variant="outlined"
                          validate={required()}
                        />
                        <TextInput
                          source="sn"
                          label="SN"
                          fullWidth
                          resettable
                          variant="outlined"
                          validate={required()}
                        />
                        <TextInput source="flightNo" label="Flight No" fullWidth resettable variant="outlined" />
                        <CustomDatetime
                          fullWidth
                          source="forwardDateToCarrier"
                          label="Forward Date To Carrier"
                          inputVariant={"dialog"}
                          variant="outlined"
                          showTime
                          validate={required()}
                          onChange={resetValidate(form)}
                          onBlur={resetValidate(form)}
                        />
                        <SelectInput
                          source="shipmentType"
                          label="Shipment Type"
                          choices={shipmentTypeList}
                          optionText="parameterDesc"
                          optionValue="parameterValue"
                          fullWidth
                          onChange={onChangeShipType}
                          variant="outlined"
                          validate={required()}
                        />
                        {orderNumberAndTypeVisible && (
                          <TextInput
                            source="orderNumber"
                            label="Order Number"
                            fullWidth
                            resettable
                            variant="outlined"
                            validate={required()}
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={5}>
                        <TextInput
                          source="awb"
                          label="AWB No"
                          fullWidth
                          resettable
                          variant="outlined"
                          validate={required()}
                        />
                        <NumberInput
                          source="xoNo"
                          label="XO Number"
                          fullWidth
                          resettable
                          variant="outlined"
                          max={99999999}
                          validate={[
                            value => (!value || value.toString().length <= 8 ? undefined : "Maximum 8 digits allowed"),
                          ]}
                        />
                        <SelectInput
                          source="carrierEnum"
                          label="Carrier"
                          choices={GetCarrierType}
                          optionText="Description"
                          optionValue="Value"
                          fullWidth
                          variant="outlined"
                          validate={required()}
                        />
                        <CustomDatetime
                          fullWidth
                          source="estimatedDeliveryDate"
                          label="Estimated Delivery Date"
                          inputVariant={"dialog"}
                          variant="outlined"
                          showTime
                          minDate={values.forwardDateToCarrier}
                          validate={[minValue(values.forwardDateToCarrier), required()]}
                          onChange={resetValidate(form)}
                          onBlur={resetValidate(form)}
                        />
                        {orderNumberAndTypeVisible && (
                          <SelectInput
                            source="orderType"
                            label="Order Type"
                            choices={orderTypeList}
                            optionText="parameterDesc"
                            optionValue="parameterValue"
                            fullWidth
                            validate={required()}
                            variant="outlined"
                          />
                        )}
                      </Grid>
                    </Grid>
                    <Grid {...gridContainerProps}>
                      <Grid item xs={12} sm={5}></Grid>
                      <Grid item xs={12} sm={5}>
                        {values.isCid == true && (
                          <TextInput
                            disabled={props.isPageDisabled || user?.isCustomer === false}
                            source="cidDescription"
                            label="Cid Remark"
                            multiline
                            minRows={3}
                            fullWidth
                            resettable
                            variant="outlined"
                          />
                        )}
                      </Grid>
                    </Grid>
                    <Separator />

                    <Toolbar {...props} placeholder="" classes={classes}>
                      {user?.isCustomer === false && (
                        <Button
                          label={loading ? "Serviceable is creating!" : "Create Serviceable"}
                          disabled={loading ? true : isDisabledProcess(values)()}
                          size="medium"
                          variant="contained"
                          color="primary"
                          onClick={handleSubmit}
                        >
                          {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                        </Button>
                      )}
                    </Toolbar>
                  </>
                </Create>
              </Grid>
            </Grid>
          </form>
        )}
      />
      <ExperienceSoftWarningDialog data={props?.requestDetail?.experience} type={ExperienceNoteType.Serviceable} />
    </>
  );
};

const PbhRequestServiceableCreate = props => {
  return (
    <ServiceableCreate
      resource="/pbhrequestserviceables"
      basePath=""
      requestId={props?.requestId}
      requestDetail={props?.requestDetail}
      finalCallBack={e => props.finalCallBack()}
    />
  );
};

export default PbhRequestServiceableCreate;
